import{css}from'glamor';export default css({padding:0,margin:0,border:'none',textAlign:'left',alignItems:'stretch',width:'100%',cursor:'pointer'}).toString();